import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message

import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { getSortedUsers } from '../../utils/UserUtils';
import { formatUserFullNameForDisplay } from '../../utils/UserUtils';
import { FilterOptionTypes } from './Constants';

const makeUserSelectOption = (user, assetTypeDisplayName, multi) => {
  const {
    id,
    email,
    ownedAssetCount
  } = user;
  return {
    value: id,
    text: formatUserFullNameForDisplay(user),
    type: FilterOptionTypes.USER,
    ownedAssetCount,
    assetTypeDisplayName,
    multi,
    avatar: /*#__PURE__*/_jsx(UIAvatar, {
      size: "xs",
      displayName: email,
      lookup: {
        type: 'hubSpotUserEmail',
        primaryIdentifier: email
      }
    })
  };
};

const getUserOptions = ({
  users,
  assetTypeDisplayName,
  userHasTeamAssignmentScope,
  multi
}) => {
  const options = !userHasTeamAssignmentScope || users.length === 0 ? [] : getSortedUsers(users).map(user => makeUserSelectOption(user, assetTypeDisplayName, multi));
  return [{
    text: I18n.text('ui-asset-management-lib.labels.users'),
    options
  }];
};

export default getUserOptions;